const networkList = process.env.REACT_APP_ALLOWED_NETWORKS && process.env.REACT_APP_ALLOWED_NETWORKS.split(',').map(item => item.trim());
export const ALLOWED_NETWORKS = networkList && networkList.length ? networkList : ['0x38'];

export const FAKE_NOTIFICATION_LIST = [
    {
        picture: '',
        title: 'Title Lorem Ipsum',
        text: '@fuadasa2 has followed you'
    },
    {
        picture: '',
        title: 'Title Lorem Ipsum',
        text: '@fuadasa2 has followed you'
    },
    {
        picture: '',
        title: 'Title Lorem Ipsum',
        text: '@fuadasa2 has followed you'
    }
]